/**
 * @module interface
 */
export interface V2TimTextElem {
    text?: string;
}
